import './css/fonts/titillium-web/titillium-web-v8-latin-regular.eot';
import './css/fonts/titillium-web/titillium-web-v8-latin-regular.svg';
import './css/fonts/titillium-web/titillium-web-v8-latin-regular.ttf';
import './css/fonts/titillium-web/titillium-web-v8-latin-regular.woff';
import './css/fonts/titillium-web/titillium-web-v8-latin-regular.woff2';

import './css/fonts/titillium-web/titillium-web-v8-latin-700.eot';
import './css/fonts/titillium-web/titillium-web-v8-latin-700.svg';
import './css/fonts/titillium-web/titillium-web-v8-latin-700.ttf';
import './css/fonts/titillium-web/titillium-web-v8-latin-700.woff';
import './css/fonts/titillium-web/titillium-web-v8-latin-700.woff2';

import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/jquery-loader';
import 'bootstrap';

import './css/site.css';
import './css/nav.css';

import smoothscroll from './polyfills/smoothscroll';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import I18n from "redux-i18n"
import { translations } from './translations';

import * as apiClient from './store/apiClient';
import * as images from './utils/images';
import configureStore from './store/configureStore';
import Routes from './components/routes';
import { connectSignalR } from './store/signalrClient';
import moment from 'moment';

function renderApp() {
    // Create browser history to use in the Redux store
    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
    const history = createBrowserHistory({ basename: baseUrl });

    // Get the application-wide store instance, prepopulating with state from the server where available.
    const store = configureStore(history);

    const rootElement = document.getElementById('root');

    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.render(<Provider store={store}>
                <I18n translations={translations} initialLang="en-GB" fallbackLang="en-GB">
                    <ConnectedRouter history={history} >
                        <Routes />
                    </ConnectedRouter>
                </I18n>
            </Provider>
        , rootElement);

    // setup polyfills
    smoothscroll();

}

// Allow Hot Module Replacement
//if (module.hot) {
//    module.hot.accept('./components/routes', () => {
//        routes = require<typeof RoutesModule>('./components/routes').routes;
//        renderApp();
//    });
//}

export interface IAppConfig {
    appVer: string;
    serverBaseUrl: string;
    images: any;
}

// https://stackoverflow.com/questions/34357489/calling-webpacked-code-from-outside-html-script-tag

export class AlphaAdminApp {

    static configure = (config: IAppConfig) => {
        console.log('configuring app');
        apiClient.setBaseUrl(config.serverBaseUrl);
        apiClient.setAppVersion(config.appVer);
        images.initialize(config.images);

        connectSignalR(config.serverBaseUrl);

        renderApp();
    }
}

declare global {
    interface Window {
        AlphaAdminApp: AlphaAdminApp;
    }
}

window.AlphaAdminApp = AlphaAdminApp;
